import { EFM_MANDANT_ID, VERDAS_MANDANT_ID } from '@/constants';

export default class MandantService {
  public isEfm(mandantId: number): boolean {
    return mandantId === EFM_MANDANT_ID;
  }

  public isVerdas(mandantId: number): boolean {
    return mandantId === VERDAS_MANDANT_ID;
  }

  public extractMandant(mandantId: string | string[] | number | null): MandantInfo {
    if (mandantId == null || mandantId == -1) {
      return { isEfm: false, isVerdas: false, unknown: true, mandantId: -1 };
    }
    const mandant = Number(mandantId);
    return {
      isEfm: this.isEfm(mandant),
      isVerdas: this.isVerdas(mandant),
      unknown: !this.isEfm(mandant) && !this.isVerdas(mandant),
      mandantId: mandant,
    };
  }
}

export type MandantInfo = {
  isEfm: boolean;
  isVerdas: boolean;
  unknown: boolean;
  mandantId: number;
};
